import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import SetupPassword from './pages/SetupPassword';
import Dashboard from './pages/Dashboard';
import Questionnaire from './pages/Questionnaire';
import AdminDashboard from './pages/AdminDashboard';
import AdminUsers from './pages/AdminUsers';
import AdminCycles from './pages/AdminCycles';
import AdminQuestionnaires from './pages/AdminQuestionnaires';
import AdminPreview from './pages/AdminPreview';
import AdminDocReview from './pages/AdminDocReview';
import AdminHome from './pages/AdminHome';
import AdminSurvey from './pages/AdminSurvey';
import AdminParticipants from './pages/AdminParticipants';

function ProtectedRoute({ children, adminOnly = false }: { children: React.ReactNode; adminOnly?: boolean }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.org_layer !== 'admin') return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <div className="app-shell">
      {user && <Navbar />}
      <Routes>
        <Route path="/login" element={user ? <Navigate to={user.org_layer === 'admin' ? '/admin' : '/dashboard'} /> : <Login />} />
        <Route path="/setup-password" element={<SetupPassword />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/questionnaire/:id" element={<ProtectedRoute><Questionnaire /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><AdminHome /></ProtectedRoute>} />
        <Route path="/admin/dashboard" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin/users" element={<ProtectedRoute adminOnly><AdminUsers /></ProtectedRoute>} />
        <Route path="/admin/cycles" element={<ProtectedRoute adminOnly><AdminCycles /></ProtectedRoute>} />
        <Route path="/admin/cycles/:cycleId/questionnaires" element={<ProtectedRoute adminOnly><AdminQuestionnaires /></ProtectedRoute>} />
        <Route path="/admin/cycles/:cycleId/participants" element={<ProtectedRoute adminOnly><AdminParticipants /></ProtectedRoute>} />
        <Route path="/admin/questionnaires/:templateId/preview" element={<ProtectedRoute adminOnly><AdminPreview /></ProtectedRoute>} />
        <Route path="/admin/review/:userId/:cycleId" element={<ProtectedRoute adminOnly><AdminDocReview /></ProtectedRoute>} />
        <Route path="/admin/survey/:templateId" element={<ProtectedRoute adminOnly><AdminSurvey /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to={user ? (user.org_layer === 'admin' ? '/admin' : '/dashboard') : '/login'} />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
